module.exports = __webpack_public_path__ + "static/media/rt-box.dffbc80d.png";